module.exports = __webpack_public_path__ + "static/media/NFBC.52d7334a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/shgn/footerLogos/mobile/NFBC.svg
// module id = 102
// module chunks = 0